import React from 'react'
import {
  Wrapper,
  LeftContainer,
  RightContainer,
  ImagesWrapper,
  PhoneImage,
  ButtonsWrapper,
  CardImage,
  JoinImg,
  Title,
  Button,
  ReadMoreWrapper,
  DownloadTitle,
  JoinTitle,
  LanguageWrapper,
  Container,
  BottomJoinTitle,
  LeftImage,
  ShopWrapper,
  ReadMoreText,
  PromotionImage,
  ShopContainer,
} from './TopSection.style'
import { LanguageType } from 'types'
import config from 'config'
import { getAppFlavor, isFitanu } from 'config/theme'
import { ShopButton, LanguageSelector } from 'components'
import img from 'images'
import { useTranslation } from 'react-i18next'
import images from 'images'

const TopSection = () => {
  const onButtonClick = () => {
    document?.getElementById('app-description')?.scrollIntoView()
  }
  const { t } = useTranslation()
  const appFlavor = getAppFlavor()
  const appLanguage = config.LANGUAGE as LanguageType

  return (
    <Wrapper container>
      <LanguageWrapper>
        <LanguageSelector />
      </LanguageWrapper>
      {isFitanu() ? (
        <>
          <LeftContainer item xs={12} sm={6}>
            <div>
              <JoinTitle>{t('JOIN_THE_CLUB')}</JoinTitle>
              <JoinImg src={img[appLanguage].joinClub[appFlavor]} />
            </div>
            <ReadMoreWrapper>
              <Title>{t(`${appFlavor}_JOIN_NOW_TITLE`)}</Title>
              <Button
                color='primary'
                variant='outlined'
                onClick={onButtonClick}
              >
                {t('topSection.readMore')}
              </Button>
            </ReadMoreWrapper>
            <DownloadTitle>{t('topSection.downloadApp')}</DownloadTitle>
            <ButtonsWrapper>
              <ShopButton shop='apple' />
              <ShopButton shop='google' />
            </ButtonsWrapper>
          </LeftContainer>
          <RightContainer item xs={12} sm={6}>
            <ImagesWrapper>
              <PhoneImage src={img[appLanguage].phone[appFlavor]} />
              <CardImage src={img[appLanguage].card[appFlavor]} />
            </ImagesWrapper>
          </RightContainer>
        </>
      ) : (
        <>
          <Container>
            <JoinTitle>{t(`MARTES_REGISTER_NOW_TITLE_UPPER`)}</JoinTitle>
            <BottomJoinTitle>{t(`MARTES_REGISTER_NOW_TITLE`)}</BottomJoinTitle>
            <ReadMoreWrapper>
              <PromotionImage src={images.promotion} />
              <ReadMoreText>
                <Title style={{ fontWeight: 700 }}>
                  {t(`MARTES_JOIN_NOW_TITLE_BOLD`)}
                </Title>
                <Title>{t(`MARTES_JOIN_NOW_TITLE`)}</Title>
                <Button variant='outlined' onClick={onButtonClick}>
                  {t('topSection.readMore')}
                </Button>
              </ReadMoreText>
            </ReadMoreWrapper>
          </Container>
          <ImagesWrapper>
            <LeftImage src={images.happyPhoto} />
            <PhoneImage src={img[appLanguage].phone[appFlavor]} />
          </ImagesWrapper>
          <ShopWrapper>
            <ShopContainer>
              <DownloadTitle>{t('topSection.downloadApp')}</DownloadTitle>
              <ButtonsWrapper>
                <ShopButton shop='apple' />
                <ShopButton shop='google' />
              </ButtonsWrapper>
            </ShopContainer>
          </ShopWrapper>
        </>
      )}
    </Wrapper>
  )
}

export default TopSection
